import { HelperResult, StudentPathDossier } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useGetLastStudentPathDossier, useUpdate: useUpdateLastStudentPathDossier } =
  getCRUDHooks({
    entityName: 'studentPathDossier',
    update: (
      {
        doNotAssignMentorDate,
      }: {
        doNotAssignMentorDate: string | null;
      },
      { userId }: { userId: number }
    ): HelperResult<StudentPathDossier> =>
      clientApi
        .getOCClient()
        .helpers.user.users.partialUpdateLastStudentPathDossier(userId, doNotAssignMentorDate),
    get: ({ userId }: { userId: number }): HelperResult<StudentPathDossier> =>
      clientApi.getOCClient().helpers.user.users.getLastStudentPathDossier(userId),
  });

export { useGetLastStudentPathDossier, useUpdateLastStudentPathDossier };
